import { navLinks } from "./Navbar";
import { siteMeta } from "@/mocks/daily";

const colChips = ["娱乐", "社会", "科技", "财经", "文体", "民生", "国际"];

export default function Footer() {
  return (
    <footer className="w-full bg-background-200 text-foreground-800">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 py-10 md:py-12">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-serif text-xl font-black tracking-tight text-foreground-950">
                每日<span className="text-primary-500">爆料</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              {siteMeta.slogan}。每日整理汇总、合集与盘点，全网热点一次看够，不错过任何精彩。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {["娱乐", "社会", "科技"].map((c) => (
                <a
                  key={c}
                  href="#featured"
                  className="whitespace-nowrap rounded-full border border-background-300 bg-background-50/60 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  {c}精选
                </a>
              ))}
            </div>
          </div>

          {/* 快速导航 */}
          <nav aria-label="页脚导航" className="lg:col-span-1">
            <h3 className="text-sm font-bold text-foreground-950">快速导航</h3>
            <ul className="mt-4 grid grid-cols-1 gap-2">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 本站栏目 */}
          <div className="lg:col-span-1">
            <h3 className="text-sm font-bold text-foreground-950">本站栏目</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {colChips.map((c) => (
                <a
                  key={c}
                  href="#featured"
                  className="whitespace-nowrap rounded-md bg-background-50/70 border border-background-300 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-background-50 hover:text-primary-600"
                >
                  {c}
                </a>
              ))}
            </div>
            <p className="mt-4 text-xs leading-relaxed text-foreground-500">
              栏目内容随话题热度滚动更新，每日一刊精选，周末一份合集。
            </p>
          </div>

          {/* 联系 */}
          <div className="lg:col-span-1">
            <h3 className="text-sm font-bold text-foreground-950">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <a href={`mailto:${siteMeta.tipsEmail}`} className="inline-flex items-center gap-2 text-foreground-600 transition-colors hover:text-primary-600">
                  <i className="ri-mail-line text-primary-500" aria-hidden="true"></i>
                  {siteMeta.tipsEmail}
                </a>
              </li>
              <li>
                <a href={`mailto:${siteMeta.contactEmail}`} className="inline-flex items-center gap-2 text-foreground-600 transition-colors hover:text-primary-600">
                  <i className="ri-question-answer-line text-secondary-600" aria-hidden="true"></i>
                  商务与转载：{siteMeta.contactEmail}
                </a>
              </li>
              <li className="flex items-center gap-2 text-foreground-600">
                <i className="ri-shield-check-line text-secondary-600" aria-hidden="true"></i>
                内容仅做资讯速览，仅供参考
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-5 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 每日爆料 Daily Buzz · 全网热点一次看够</p>
          <p className="inline-flex items-center gap-1.5">
            每日整理 · 滚动更新
            <span className="h-1 w-1 rounded-full bg-background-400" aria-hidden="true"></span>
            期待你的线索
          </p>
        </div>
      </div>
    </footer>
  );
}